@if (vwData()) {
  <div class="vw-data space-y-6 rounded-lg bg-white lg:p-4">
    @if (vwData()?.chapters && (vwData()?.chapters?.length ?? 0) > 0) {
      <div class="space-y-6">
        @for (chapter of vwData()?.chapters; track chapter.id) {
          <div class="space-y-4 rounded-lg border border-gray-200 p-4">
            <!-- <div class="mb-3 border-b">
              <div class="flex items-center justify-between">
                <div class="bg-violet-50 text-xs">{{ chapter | json }}</div>
                <h3 class="text-lg font-semibold text-gray-900">
                  @if (chapter.title) {
                    {{ chapter.title }}
                  }
                </h3>
                <span class="whitespace-nowrap text-sm text-gray-500">ID: {{ chapter.id }}</span>
              </div>
            </div> -->

            <div class="text-sm text-gray-600">
              @let motorKb = printableList(chapter['motor-kb']);
              @if (motorKb) {
                <p>{{ 'documents.vw.labels.engineCodes' | transloco }}: {{ motorKb }}</p>
              }
              @let typeName = printableList(chapter['typen-bez']);
              @if (typeName) {
                <p>{{ 'documents.vw.labels.modelCodes' | transloco }}: {{ typeName }}</p>
              }
            </div>

            @if (chapter.children) {
              @let filteredChildren = getFilteredChildren(chapter.children);
              @if (filteredChildren.length > 0) {
                @for (child of filteredChildren; track $index) {
                  <app-vw-dynamic [element]="child" [dbId]="vwData()?.dbId" [provider]="provider" class="block"></app-vw-dynamic>
                }
              } @else {
                <div class="py-8 text-center text-sm text-gray-500">
                  {{ 'documents.vw.noResults' | transloco }}
                </div>
              }
            }
          </div>
        }
      </div>
    } @else {
      @if (vwData()?.xml_data) {
        <!-- <h2 class="text-xl font-semibold text-gray-800">{{ vwData()?.title }}</h2> -->

        @let children = vwData()?.xml_data?.children;
        <ng-template #childrenLoop>
          @for (child of children; track $index) {
            <app-vw-dynamic [element]="child" [dbId]="vwData()?.dbId" [provider]="provider" class=""></app-vw-dynamic>
          }
        </ng-template>

        @if (hasImageWithLegend()) {
          <div class="flex flex-wrap gap-4">
            <ng-container *ngTemplateOutlet="childrenLoop"></ng-container>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="childrenLoop"></ng-container>
        }
      }
    }

    <!-- Debug Information -->
    <div class="hidden border-t pt-4 text-xs text-gray-500">
      <details>
        <summary class="cursor-pointer hover:text-gray-700">Debug Information</summary>
        <pre class="mt-2 overflow-x-auto rounded bg-gray-100 p-2">{{ vwData() | json }}</pre>
      </details>
    </div>
  </div>
}
